import { Trash2 } from 'lucide-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import type { TRuleEditorCommonProps } from '../types';

interface Props extends TRuleEditorCommonProps {
  index: number;
  onRemove: () => void;
  children: ReactNode;
}

const RuleAction = ({ index, isReadOnly, onRemove, children }: Props) => {
  const { t } = useTranslation('Templates');

  return (
    <div>
      <div className="group flex flex-row justify-center">
        <strong>{t('question.ruleActions.actionLabel', { index: index + 1 })}</strong>

        <div className="hubert-vertical-center ml-2 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          {!isReadOnly ? <Trash2 className="text-danger-400 h-4 w-4 cursor-pointer" onClick={onRemove} /> : null}
        </div>
      </div>

      <div className="flex flex-row justify-between">
        <div className="hubert-vertical-center">{t('question.ruleActions.thenLabel')}</div>
      </div>

      {children}
    </div>
  );
};

export default RuleAction;
